import { render, staticRenderFns } from "./expertExtractionList.vue?vue&type=template&id=3f447098&scoped=true"
import script from "./expertExtractionList.vue?vue&type=script&lang=js"
export * from "./expertExtractionList.vue?vue&type=script&lang=js"
import style0 from "./expertExtractionList.vue?vue&type=style&index=0&id=3f447098&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f447098",
  null
  
)

export default component.exports